import React, { Component } from 'react';

const DYZIO_IDENTIFEIR = 'dyzio';

export class DyzioStorage {
  KEYS = {
    CAMPAIGN_VIEW_MODE: 'campaign-view-modes',
    CAMPAGINS_LIST_VIEW_MODE: 'campaigns-list-view-mode',
    TABLE_COLUMNS_SETTINGS: 'table-columns-settings',
    CAMPAIGNS_LIST_PER_PAGE: 'campaigns-list-per-page',
    CAMPAIGNS_LIST_SORT_BY: 'campaigns-list-sort-by',
    CAMPAIGNS_LIST_FILTER: 'campaigns-list-filter',
    UPGRADE_MODAL_KEY: 'upgrade-modal',
    SHOW_NEW_INFLUENCER_TAB_MODAL: 'new-influencer-tab',
  }

  set = (key, value) => {
    localStorage.setItem(`${DYZIO_IDENTIFEIR}-${key}`, JSON.stringify(value));
  }

  getTableColumnsSettings = ({ userId }) => {
    const record = this.get(`${this.KEYS.TABLE_COLUMNS_SETTINGS}-${userId}`);
    if (!record || !record.columns) {
      return {
        columns: {},
      };
    }
    return record;
  }

  updateTableColumnSettings = ({ userId, settings }) => {
    this.set(`${this.KEYS.TABLE_COLUMNS_SETTINGS}-${userId}`, settings);
  }

  getCampaignSettings = ({ campaignId, key }) => (this.get(`${key}-${campaignId}`));

  updateCampaignSettings = ({ campaignId, key, value }) => (this.set(`${key}-${campaignId}`, value))

  get = key => {
    const value = localStorage.getItem(`${DYZIO_IDENTIFEIR}-${key}`);
    try {
      return value ? JSON.parse(value) : {};
    } catch (error) {
      return {};
    }
  }
}

const hasLocalStorageClient = WrapperComponent => class HasLocalStorageClient extends Component {
  render() {
    return (<WrapperComponent {...this.props} dyzioStorage={new DyzioStorage()} />);
  }
};

export default hasLocalStorageClient;



/** WEBPACK FOOTER **
 ** ./src/hocs/has-localstorage-client/index.js
 **/